export default __webpack_public_path__ + "static/media/office.f199fd99.jpg";